"use client";

import { getIconSelectionFromFields } from "@2u-landing-pages/utils";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import React from "react";
import { CustomCSSProperties, TileProps } from "./Tile.types";
import { Default } from "./variations/Default";
import { Divider } from "./variations/Divider";

export const Tile: React.FC<TileProps> = ({ style: styleProp, content, ...rest }) => {
  const inspector = useContentfulInspectorMode();
  const style: CustomCSSProperties = { ...styleProp };
  const fields = content?.fields as Record<string, unknown> | undefined;
  const iconSelectionData = getIconSelectionFromFields(fields, ["size", "color"]);
  const iconColor = iconSelectionData.color?.trim() ?? "";
  if (content?.fields?.eyebrow_color) style["--tile-eyebrow-color"] = `var(${content.fields.eyebrow_color})`;
  if (content?.fields?.heading_color) style["--tile-heading-color"] = `var(${content.fields.heading_color})`;
  if (content?.fields?.subhead_color) style["--tile-subhead-color"] = `var(${content.fields.subhead_color})`;
  if (content?.fields?.body_color) style["--tile-body-color"] = `var(${content.fields.body_color})`;
  if (iconColor) style["--tile-icon-color"] = iconColor.startsWith("--") ? `var(${iconColor})` : iconColor;

  if (content?.fields?.variation === "divider") {
    return (
      <Divider {...rest} style={style} content={content} iconSelectionData={iconSelectionData} inspector={inspector} />
    );
  } else {
    return (
      <Default {...rest} style={style} content={content} iconSelectionData={iconSelectionData} inspector={inspector} />
    );
  }
};
